import { writable } from 'svelte/store';

export const filterStore = writable([]);

export const range1 = writable(0);

export const rangesStore = writable({
    range1: 0,
    range2: 0,
    range3: 0,
});

export const menuOpen = writable( false );

export function filterHash( filters, ranges ){
    let hash = filters.sort().join('-');
    hash += JSON.stringify(ranges);
    return hash;
}

export function filterPosts( posts, filters, ranges ){
    return posts.filter( post => {

        if( filters.length > 0 && filters.find(f => post.categories.includes(f)) === undefined){
            return false;
        }

        if( ranges.range1 > 0 && ( ranges.range1 - 2 > post.range1 || ranges.range1 + 2 < post.range1 )){
            return false;
        }
        if( ranges.range2 > 0 && ( ranges.range2 - 2 > post.range2 || ranges.range2 + 2 < post.range2 )){
            return false;
        }
        if( ranges.range3 > 0 && ( ranges.range3 - 2 > post.range3 || ranges.range3 + 2 < post.range3 )){
            return false;
        }

        return true;

    });
}